import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { IntraoccularPressureLeftEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-intraoccular-pressure-left-eye-slot',
    templateUrl: './intraoccular-pressure-left-eye-slot.component.html',
    styleUrl: './intraoccular-pressure-left-eye-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntraoccularPressureLeftEyeSlotComponent implements SheetSlotComponentBase {

	action!: IntraoccularPressureLeftEyeAction;
	value!: string | null;

	@Input('action') set updateAction(action: IntraoccularPressureLeftEyeAction | null) {
		this.action = action as IntraoccularPressureLeftEyeAction;
		this.value = this.action.iop?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}